import $ from "jquery";

$("body").on("click tap", "[data-open-overlay-page]", function (e) {
    e.preventDefault();

    const lessonId = $(this).attr("data-open-overlay-page");
    const data = $(this).attr("data-open-overlay-page-data");

    $("#overlay-page").attr(
        "data-overlay-url",
        `${HOME_URL}/overlay-page/${lessonId}/${data ? `?data=${data}` : ""}`
    );

    $("#overlay-page").foundation("open");
});

$("[data-modal-overlay-page]").on("open.zf.reveal", function () {
    let url = $(this).attr("data-overlay-url");
    $("#overlay-page-content").html(
        `<iframe src="${url}" width="100%" height="640" frameborder="0"></iframe>`
    );
});

$("[data-modal-overlay-page]").on("closed.zf.reveal", function () {
    $(this).find(".sb_overlay_content").html("");
});
